import React, { useState } from 'react';

export default function FilterSelectionCard({ title, options, selected, onToggle, emptyLabel = 'Aucune option disponible', visibleCount = Infinity, compact = false }) {
  const [expanded, setExpanded] = useState(false);
  const selectedOptions = options.filter(option => selected.has(option.value));
  const availableOptions = options.filter(option => !selected.has(option.value));
  const displayedOptions = expanded ? availableOptions : availableOptions.slice(0, visibleCount);
  const hiddenCount = Math.max(0, availableOptions.length - displayedOptions.length);

  return <section className={`ticket-selection${compact ? ' ticket-selection--compact' : ''}`} aria-label={title}>
    <h3>{title}</h3>
    {selectedOptions.length > 0 && <div className="ticket-selection__selected">
      {selectedOptions.map(option => <button key={option.value} type="button" aria-label={`Retirer ${option.label}`} onClick={() => onToggle(option.value)}>
        <span>{option.label}</span><small aria-hidden="true">{option.count ?? ''}</small><b aria-hidden="true">×</b>
      </button>)}
    </div>}
    <div className="ticket-selection__available">
      {availableOptions.length > 0 ? displayedOptions.map(option => <button key={option.value} type="button" onClick={() => onToggle(option.value)}>
        <span>{option.label}</span><small aria-hidden="true">{option.count ?? ''}</small><b aria-hidden="true">+</b>
      </button>) : <p>{selectedOptions.length ? 'Toutes les options sont sélectionnées.' : emptyLabel}</p>}
      {(hiddenCount > 0 || (expanded && availableOptions.length > visibleCount)) && <button type="button" className="ticket-selection__more" aria-expanded={expanded} onClick={() => setExpanded(value => !value)}>
        <span>{expanded ? 'Réduire la liste' : `Afficher ${hiddenCount} autre${hiddenCount > 1 ? 's' : ''}`}</span><small /><b aria-hidden="true">{expanded ? '−' : '+'}</b>
      </button>}
    </div>
  </section>;
}
